import { navigationNamespace } from "@/store/modules/navigation";
import { patientNamespace } from "@/store/modules/patient";
import { Alert } from "@/store/types";
import { Component, Prop, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";

@Component({})
export default class IconList extends Vue {
  @Action("showPopup", navigationNamespace)
  showPopup!: Function;

  @Getter("config", patientNamespace)
  config!: any;

  @Getter("towerMode", patientNamespace)
  towerMode!: boolean;

  @Prop(Array)
  alerts!: Array<Alert>;

  @Prop({
    default: () => {
      return [];
    }
  })
  iconsToRemove!: Array<string>;

  @Prop(String)
  customClasses!: string;

  @Prop(String)
  location!: string;

  @Prop(String)
  overrides!: string;

  handleClick(alert: Alert) {
    if (alert.link && this.location !== "census") {
      this.showPopup(alert.link);
    }
  }

  shiftRight(alert: Alert) {
    return alert.icon.indexOf("alertCheck") === 0;
  }

  get filteredAlerts() {
    const alerts = this.alerts;
    if (!alerts || alerts.length === 0) {
      return [];
    }
    const configKey = this.location ? this.location : "body";
    const overrides = this.overrides ? this.overrides.toLowerCase() : "";
    return (
      alerts
        .filter(alert => {
          switch (overrides) {
            case "hidetower":
              return alert.slot < 90;
            case "toweronly":
              return alert.slot >= 90;
            default:
              return this.towerMode || alert.slot < 90;
          }
        })
        .filter(alert => {
          return (
            alert.slot >=
            (configKey === "body" ? this.config.icons.body.minSlot : 0)
          );
        })

        .filter(alert => {
          // must have icon
          return alert.icon;
        })
        .filter(alert => {
          if (configKey === "body") {
            return (
              (alert.slot >= 90 || alert.level !== -1) 
            );
          } else {
            return alert.level !== -2;
          }
        })
        // remove specific icons by name
        .filter(alert => {
          let found = false;
          this.iconsToRemove.forEach(icon => {
            if (!found) {
              found = alert.icon.indexOf(icon) !== -1;
            }
          });
          return !found;
        })
        // Remove matching slots, taking highest level alert
        .reduce((accumulator: Array<Alert>, alert: Alert) => {
          const sameSlot = accumulator.find(accAlert => {
            return accAlert.slot === alert.slot;
          });

          if (sameSlot) {
            if (sameSlot.level < alert.level) {
              accumulator.splice(accumulator.indexOf(sameSlot), 1, alert);
            }
          } else {
            accumulator.push(alert);
          }
          return accumulator;
        }, [])
    );
  }
}
